<template>
  <div
    id="app"
    :class="{ blurred: isBackgroundBlurred }"
  >
    <app-header v-if="pageHasHeader" />
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
    <sign-out-modal />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import throttle from 'lodash.throttle';

import config from './utils/config';

import AppHeader from '@/components/common/AppHeader';
import SignOutModal from '@/components/common/SignOutModal';

export default {
  name: 'App',
  components: {
    AppHeader,
    SignOutModal,
  },
  data: () => ({
    MAX_INACTIVITY_PERIOD: config.MAX_INACTIVITY_PERIOD || 15 * 60 * 1000,
    REFRESH_TOKEN_UPDATE_PERIOD: 15 * 60 * 1000,
    headerExclusionPaths: ['sign-in', 'password-reset', 'email-verification'],
    inactivityTimer: 0,
  }),
  computed: {
    ...mapState(['isBackgroundBlurred', 'user', 'tabId']),
    pageHasHeader() {
      const regexp = this.headerExclusionPaths.join('|');
      const headerExclusions = new RegExp(regexp, 'gi');
      return !this.$route.path.match(headerExclusions);
    },
    throttleUpdateTimer() {
      return throttle(this.updateInactivityTimer, 10 * 1000, { leading: false });
    },
  },
  watch: {
    user(val, prev) {
      if (!prev) {
        this.updateInactivityTimer(true);
      }
    },
  },
  created() {
    if (this.$config.NODE_ENV !== 'development') {
      this.checkVersion();
    }

    this.updateRefreshToken();
    setInterval(this.updateRefreshToken, this.REFRESH_TOKEN_UPDATE_PERIOD);

    this.updateInactivityTimer(true);

    window.addEventListener('storage', this.onStorageChange);
  },
  methods: {
    async updateRefreshToken() {
      if (localStorage.refreshToken) {
        await this.$http.post('users/1.0/token-validate', {
          token: localStorage.refreshToken,
        });
      }
    },
    deactivateUser() {
      window.removeEventListener('click', this.throttleUpdateTimer);
      window.removeEventListener('mousemove', this.throttleUpdateTimer);
      window.removeEventListener('scroll', this.throttleUpdateTimer);

      if (localStorage.activeTab !== this.tabId) {
        return;
      }

      this.$store.commit('logOut');

      if (this.$route.name !== 'SignIn') {
        this.$store.commit('toggleSignOutModal', {
          isShown: true,
          text: 'Вы были неактивны в течение 15 минут. Пожалуйста, авторизуйтесь снова',
        });
      }
    },
    updateInactivityTimer(created) {
      if (created) {
        window.addEventListener('scroll', this.throttleUpdateTimer);
        window.addEventListener('click', this.throttleUpdateTimer);
        window.addEventListener('mousemove', this.throttleUpdateTimer);
      }

      this.$store.commit('updateActiveTab');

      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }

      this.inactivityTimer = setTimeout(this.deactivateUser, this.MAX_INACTIVITY_PERIOD);
    },
    onStorageChange(e) {
      if (e.key === 'jwtacc' && !e.newValue) {
        this.$router.push('/sign-in');

        if (this.inactivityTimer) {
          clearTimeout(this.inactivityTimer);
        }
      }
    },
    async checkVersion() {
      await this.$http.post(`/front-versions/${this.$config.CONTAINER_NAME}`);
    },
  },
};
</script>
